module.exports = __webpack_public_path__ + "static/media/ArrowDown.c5545ee4.svg";